import twitter from "../../../../assets/icons/twitter.png";
import { Discord } from "../../../../assets/icons/Discord";
import TrashIcon from "assets/icons/TrashIcon";
import { IDApp } from "screens/DApps/types";
import { EditIcon } from "assets/icons/Edit";
import { useDAppsStore } from "screens/DApps/store";

export const DAppCard = ({
  dApp,
  setIsDeleteModalOpen,
  setIdToDelete,
}: {
  dApp: IDApp;
  setIsDeleteModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIdToDelete: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const { setDAppForEdit } = useDAppsStore();

  return (
    <>
      <img
        src={`${dApp.image}`}
        className="min-w-[40px] w-[40px] h-[40px] object-cover rounded-full"
        alt=""
      />

      <h2 className="text-[18px] font-[500] leading-[24px] text-left">
        {dApp?.name}
      </h2>

      <span className="text-[14px] font-[500] leading-[18px] text-[#DADADA99] break-all">
        {dApp.description}
      </span>

      <div className="flex mt-auto items-center">
        <div className="flex flex-col gap-1">
          {!!dApp.ecosystems.length && (
            <div className="max-h-[30px] overflow-visible">
              <ul className="flex gap-1 max-w-[200px] custom-scrollbar overflow-x-auto">
                {dApp.ecosystems?.map((ecosystem) => (
                  <div
                    key={ecosystem.id}
                    className="truncate flex-none max-w-full flex justify-start items-center py-[6px] px-[16px] bg-[#202020] text-[14px] font-[500] leading-[18px] text-[#DADADA99]"
                  >
                    {ecosystem.name}
                  </div>
                ))}
              </ul>
            </div>
          )}

          <div className="max-h-[30px] overflow-visible">
            <ul className="flex gap-1 max-w-[200px] custom-scrollbar overflow-x-auto">
              {!!dApp?.tags?.length &&
                dApp.tags?.map((tag) => (
                  <div
                    key={tag.id}
                    className="truncate flex-none max-w-full flex justify-start items-center py-[6px] px-[16px] bg-[#202020] text-[14px] font-[500] leading-[18px] text-[#DADADA99]"
                  >
                    {tag.name}
                  </div>
                ))}
            </ul>
          </div>
        </div>

        <div className="ms-auto flex items-center gap-[16px]">
          {!!dApp.twitter_url && (
            <a
              href={dApp.twitter_url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X (Twitter)"
              className="flex justify-center items-center w-[16px] h-[16px]"
              style={{ textDecoration: "none" }}
              onClick={(e) => e.stopPropagation()}
            >
              <img src={twitter} alt="" />
            </a>
          )}

          {!!dApp.discord_url && (
            <a
              href={dApp.discord_url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Discord"
              className="flex justify-center items-center"
              style={{ textDecoration: "none" }}
              onClick={(e) => e.stopPropagation()}
            >
              <Discord width={20} height={20} />
            </a>
          )}
        </div>
      </div>

      <div className="absolute top-0 right-0 flex gap-[8px] bg-[#111111] pl-2 pb-2">
        <button
          className="dapp-page--grid-item--action"
          aria-label="Open"
          onClick={(e) => {
            e.stopPropagation();
            setDAppForEdit(dApp);
          }}
        >
          <EditIcon width={14} height={14} />
        </button>

        <button
          className="dapp-page--grid-item--action-delete"
          aria-label="Open"
          onClick={(e) => {
            e.stopPropagation();
            setIdToDelete(dApp.id);
            setIsDeleteModalOpen(true);
          }}
        >
          <TrashIcon width={16} height={16} />
        </button>
      </div>
    </>
  );
};
